import core from './core';

export default {
  me() {
    return core.get('me');
  },

  identities() {
    return core.get('me/identities');
  },

  sendCode(phone) {
    return core.post('/send-code', {
      phone,
    });
  },
}
